import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import authService from '../../services/authService';
import { Button } from '../common/index.js';
import logo from "../../static/images/logo.png";

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const response = await authService.forgotPassword(email);
      setMessage(response.message);

      sessionStorage.setItem('resetEmail', email);

      setTimeout(() => {
        navigate('/reset-password');
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-light flex items-center justify-center px-4 relative">

      <Link to="/" className="absolute top-6 left-6">
        <Button variant="primary" size="sm" icon={ArrowLeft}>
          Back to Home
        </Button>
      </Link>

      <div className="w-full max-w-5xl bg-white rounded-card shadow-equal grid grid-cols-1 lg:grid-cols-2">

        <div className="hidden lg:flex items-center justify-center bg-brand-light text-secondary relative overflow-hidden rounded-l-card">
          <div className="text-center px-12">
            <img
              src={logo}
              alt="Metro Logistics"
              className="mx-auto mb-8 max-w-[160px]"
            />
            <h2 className="text-2xl font-semibold leading-tight text-brand">
              Recover your account securely
            </h2>
            <p className="mt-4 text-secondary text-sm">
              We'll help you reset your password and get back on track
            </p>
          </div>
        </div>

        <div className="p-8 sm:p-12">

          <h1 className="text-2xl font-semibold text-brand">
            Forgot Password
          </h1>
          <p className="text-sm text-gray-500 mt-1">
            Enter your registered email to receive an OTP
          </p>

          {error && (
            <div className="mt-6 bg-red-50 border border-red-200 text-danger px-4 py-3 rounded-card text-sm">
              {error}
            </div>
          )}

          {message && (
            <div className="mt-6 bg-green-50 border border-green-200 text-success px-4 py-3 rounded-card text-sm">
              {message}
              <p className="text-xs mt-1 text-emerald-600">
                Redirecting to reset password…
              </p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="mt-8 space-y-6">

            <div>
              <label className="text-sm font-medium text-secondary">
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-clean mt-2"
                placeholder="Enter your registered email"
                required
                disabled={loading}
              />
            </div>

            <Button type="submit" loading={loading} className="w-full" size="lg">
              Send OTP
            </Button>
          </form>

          <div className="mt-6 pt-6 border-t border-gray-200 text-center">
            <Link
              to="/login"
              className="text-sm text-brand hover:underline font-medium"
            >
              ← Back to Login
            </Link>
          </div>

        </div>
      </div>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-sm text-secondary">
        © 2026 Metro Logistics. All rights reserved.
      </div>

    </div>
  );
};

export default ForgotPassword;
